// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CopyMemoMutationVariables = Types.Exact<{
  input: Types.CopyMemoInput;
}>;


export type CopyMemoMutation = { __typename?: 'Mutation', copyMemo: { __typename?: 'Memo', id: string } };

export const Operations = {
  Mutation: {
    CopyMemo: 'CopyMemo' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CopyMemoDocument = gql`
    mutation CopyMemo($input: CopyMemoInput!) {
  copyMemo(input: $input) {
    id
  }
}
    `;
export type CopyMemoMutationFn = Apollo.MutationFunction<CopyMemoMutation, CopyMemoMutationVariables>;

/**
 * __useCopyMemoMutation__
 *
 * To run a mutation, you first call `useCopyMemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyMemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyMemoMutation, { data, loading, error }] = useCopyMemoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyMemoMutation(baseOptions?: Apollo.MutationHookOptions<CopyMemoMutation, CopyMemoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyMemoMutation, CopyMemoMutationVariables>(CopyMemoDocument, options);
      }
export type CopyMemoMutationHookResult = ReturnType<typeof useCopyMemoMutation>;
export type CopyMemoMutationResult = Apollo.MutationResult<CopyMemoMutation>;
export type CopyMemoMutationOptions = Apollo.BaseMutationOptions<CopyMemoMutation, CopyMemoMutationVariables>;